var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubtitles = function SvgSubtitles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 14,
    x: 0.5,
    y: 5,
    ry: 2.5,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61 15.332a3.422 3.593 78.898 0 1-3.635-1.393 3.422 3.593 78.898 0 1-.04-3.766 3.422 3.593 78.898 0 1 3.604-1.59M17.605 15.283a3.422 3.593 78.898 0 1-3.635-1.393 3.422 3.593 78.898 0 1-.04-3.766 3.422 3.593 78.898 0 1 3.604-1.59"
  })));
};
export default SvgSubtitles;